import { render, staticRenderFns } from "./vehicle_status_upcoming.vue?vue&type=template&id=f0061d64&scoped=true&"
import script from "./vehicle_status_upcoming.vue?vue&type=script&lang=js&"
export * from "./vehicle_status_upcoming.vue?vue&type=script&lang=js&"
import style0 from "./vehicle_status_upcoming.vue?vue&type=style&index=0&id=f0061d64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0061d64",
  null
  
)

export default component.exports